export default "__VITE_ASSET__b1aJVSf2__"